import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const AI_SEARCH_BASE_URL="https://wf-search-index-api.azurewebsites.net";

const slice = createSlice({
    name: "wordProccessing",
    initialState: {
        list: [],
        loading: false,
        lastFetch: null,
        htmlToPdfConvert: null,
        docToDocxConvert: null,
        htmlToDocxConvert: null,
        addedStatus: false,
        lockedStatus: false,
        versionList:[],
        searchDocList:[]
    },
    reducers: {
        wordRequestStarted: (wordProccessing) => {
            wordProccessing.loading = true;
            wordProccessing.addedStatus = false;
            wordProccessing.lockedStatus = false;
        },
        wordRequestFailed: (wordProccessing) => {
            wordProccessing.loading = false;
        },
        wordTemplateReceived: (wordProccessing, action) => {
            wordProccessing.list = action.payload;
            wordProccessing.addedStatus = false;
            wordProccessing.lockedStatus = false;
            wordProccessing.loading = false;
        },
        htmlToPdfConvertedReceived: (wordProccessing, action) => {
            wordProccessing.htmlToPdfConvert = action.payload;
            wordProccessing.loading = false;
        },
        docToDocxConvertedReceived: (wordProccessing, action) => {
            wordProccessing.docToDocxConvert = action.payload;
            wordProccessing.loading = false;
        },
        htmlToDocxConvertedReceived: (wordProccessing, action) => {
            wordProccessing.htmlToDocxConvert = action.payload;
            wordProccessing.loading = false;
        },
        wordTemplateAdded: (wordProccessing, action) => {
            wordProccessing.addedStatus = action.payload;
            wordProccessing.loading = false;
        },
        wordTemplateLocked: (wordProccessing, action) => {
            wordProccessing.lockedStatus = action.payload;
            wordProccessing.loading = false;
        },
        versionTemplateReceived: (wordProccessing, action) => {
            wordProccessing.versionList = action.payload;
            wordProccessing.loading = false;
        },
        searchDocListReceived: (wordProccessing, action) => {
            wordProccessing.searchDocList = action.payload;
            wordProccessing.loading = false;
        },
    }
});

export const { wordRequestStarted, wordRequestFailed, wordTemplateReceived, htmlToPdfConvertedReceived, docToDocxConvertedReceived,
    htmlToDocxConvertedReceived, wordTemplateAdded,wordTemplateLocked,
    versionTemplateReceived,searchDocListReceived } = slice.actions;
export default slice.reducer;

export const loadWordTemplates = (id) => apiCallBegan({
    url: config.GetWordTemplates + id,
    onStart: { type: wordRequestStarted.type },
    onError: { type: wordRequestFailed.type },
    onSuccess: wordTemplateReceived.type
});

export const loadVersionWordTemplates = (id) => apiCallBegan({
    url: config.GetWordVersionTemplates + id,
    onStart: { type: wordRequestStarted.type },
    onError: { type: wordRequestFailed.type },
    onSuccess: versionTemplateReceived.type
});

export const SetWordTemplateLocked = (id) => apiCallBegan({
    url: config.SetWordDocumentLocked + id,
    onStart: { type: wordRequestStarted.type },
    onError: { type: wordRequestFailed.type },
    onSuccess: wordTemplateLocked.type
});

export const loadDocumentSearch = (data) => apiCallBegan({
    baseURL: AI_SEARCH_BASE_URL,
    url: config.DocumentAiSearch,
    method:"post",
    data: data,
    onStart: { type: wordRequestStarted.type },
    onError: { type: wordRequestFailed.type },
    onSuccess: searchDocListReceived.type
});

export const addWordTemplate = (data) => apiCallBegan({
    url: config.AddWordTemplate,
    method: "post",
    data: data,
    onStart: { type: wordRequestStarted.type },
    onError: { type: wordRequestFailed.type },
    onSuccess: wordTemplateAdded.type
});

export const convertHtmlToPdf = (data) => apiCallBegan({
    url: config.PrintTemplate,
    method: "post",
    data: data,
    responseType: "blob",
    onStart: { type: wordRequestStarted.type },
    onError: { type: wordRequestFailed.type },
    onSuccess: htmlToPdfConvertedReceived.type
});

export const convertDocToDocx = (data) => apiCallBegan({
    url: config.ConvertDocToDocx,
    method: "post",
    data: data,
    responseType: "arraybuffer",
    onStart: { type: wordRequestStarted.type },
    onError: { type: wordRequestFailed.type },
    onSuccess: docToDocxConvertedReceived.type
});

export const convertHtmlToDocx = (data) => apiCallBegan({
    url: config.ConvertHtmlToDocx,
    method: "post",
    data: data,
    responseType: "blob",
    onStart: { type: wordRequestStarted.type },
    onError: { type: wordRequestFailed.type },
    onSuccess: htmlToDocxConvertedReceived.type
});

export const getHtmlToPdf = createSelector(
    state => state.entities.wordProccessing,
    wordProccessing => wordProccessing.htmlToPdfConvert
);

export const getDocToDocx = createSelector(
    state => state.entities.wordProccessing,
    wordProccessing => wordProccessing.docToDocxConvert
);

export const getHtmlToDocx = createSelector(
    state => state.entities.wordProccessing,
    wordProccessing => wordProccessing.htmlToDocxConvert
);

export const getWordTemplates = createSelector(
    state => state.entities.wordProccessing,
    wordProccessing => wordProccessing.list
);

export const getWordTempAddedStatus = createSelector(
    state => state.entities.wordProccessing,
    wordProccessing => wordProccessing.addedStatus
);

export const getWordTempLockedStatus = createSelector(
    state => state.entities.wordProccessing,
    wordProccessing => wordProccessing.lockedStatus
);

export const getWordVersionTemplates = createSelector(
    state => state.entities.wordProccessing,
    wordProccessing => wordProccessing.versionList
);

export const getSearchDocuments = createSelector(
    state => state.entities.wordProccessing,
    wordProccessing => wordProccessing.searchDocList
);

export const getWordLoading = createSelector(
    state => state.entities.wordProccessing,
    wordProccessing => wordProccessing.loading
);

